import { render, staticRenderFns } from "./PaymentAmount.vue?vue&type=template&id=ebc85228&scoped=true&"
import script from "./PaymentAmount.vue?vue&type=script&lang=js&"
export * from "./PaymentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc85228",
  null
  
)

export default component.exports